"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Fields = require("./Fields");
var _eventHandlers = require("../../../utils/eventHandlers");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "data-table": "data-table_34lm80",
  "dataTable": "data-table_34lm80",
  "custom-fields-toggle": "custom-fields-toggle_3M8QCa",
  "customFieldsToggle": "custom-fields-toggle_3M8QCa",
  "pill": "pill_2WgTHW",
  "pill-span": "pill-span_1ERn7s",
  "pillSpan": "pill-span_1ERn7s"
}; 
require('./CustomFields.css');
var fieldComponentsByType = {
  text: _Fields.ValueField,
  number: _Fields.ValueField,
  date: _Fields.DateField,
  enum: _Fields.ListField,
  'text-list': _Fields.ListField,
  'number-list': _Fields.ListField
};
function getValidCustomFields(customFields) {
  return customFields.filter(function (customField) {
    return !!fieldComponentsByType[customField.dataType];
  });
}
var COLLAPSED_COUNT = 3;
var CustomFields = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function CustomFields() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomFields);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CustomFields, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      showMore: false
    });
    (0, _defineProperty2.default)(_this, "onCustomFieldsToggle", function () {
      var showMore = _this.state.showMore;
      _this.setState({
        showMore: !showMore
      });
    });
    return _this;
  }
  (0, _inherits2.default)(CustomFields, _React$PureComponent);
  return (0, _createClass2.default)(CustomFields, [{
    key: "render",
    value: function render() {
      var customFields = this.props.customFields;
      var validCustomFields = getValidCustomFields(customFields);
      if (validCustomFields.length === 0) {
        return null;
      }
      var showMore = this.state.showMore;
      var showToggle = validCustomFields.length > COLLAPSED_COUNT;
      var visibleCustomFields = validCustomFields.slice(0, showMore ? validCustomFields.length : COLLAPSED_COUNT);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("table", {
        className: styles.dataTable,
        "data-test-id": "custom-fields-table"
      }, /*#__PURE__*/_react.default.createElement("tbody", null, visibleCustomFields.sort(function (a, b) {
        return a.displayName.localeCompare(b.displayName);
      }).map(function (customField) {
        var FieldComponent = fieldComponentsByType[customField.dataType];
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: customField.key
        }, /*#__PURE__*/_react.default.createElement("th", {
          scope: "col",
          title: customField.displayName
        }, customField.displayName), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(FieldComponent, {
          customField: customField
        })));
      })), /*#__PURE__*/_react.default.createElement("caption", {
        className: "visually-hidden"
      }, "Custom fields")), showToggle ? /*#__PURE__*/_react.default.createElement("div", {
        className: styles.customFieldsToggle,
        "data-test-id": "custom-fields-toggle"
      }, /*#__PURE__*/_react.default.createElement("span", {
        tabIndex: "0",
        role: "button",
        onClick: this.onCustomFieldsToggle,
        onKeyDown: (0, _eventHandlers.onEnterKey)(this.onCustomFieldsToggle)
      }, showMore ? 'Show less' : 'Show more')) : null);
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(CustomFields, "propTypes", {
  customFields: _propTypes.default.arrayOf(_propTypes.default.object)
});
(0, _defineProperty2.default)(CustomFields, "defaultProps", {
  customFields: []
});
//# sourceMappingURL=CustomFields.js.map